import { getEndpoint } from "@api-routes/endpoint";

const ELAVON_FACADE_MS_NAME = "elavon-facade";

export const getOneOffPaymentHppApiRoute = (amount?: number) =>
    `${getEndpoint(ELAVON_FACADE_MS_NAME)}hpp/payments${amount ? `?amount=${amount}` : ""}`;

export const CARDS_HPP_API_ROUTE = `${getEndpoint(ELAVON_FACADE_MS_NAME)}hpp/cards`;

export const getPaymentProviderApiRoute = (accountId: string) =>
    `${getEndpoint(ELAVON_FACADE_MS_NAME)}payments/provider?accountId=${accountId}`;
